import { useLocation, useNavigate } from 'react-router'
import { useSelector } from 'react-redux'

import './header.styles.scss'

const Header = () => {
    const { nome } = useSelector(state => state.user)
    const { pathname } = useLocation()
    const navigate = useNavigate()
    return (
        <header>
            <img className='logo' src='https://i.imgur.com/CDTVvFD.png' alt='ipas-logo' width='180px' height='auto' 
                onClick={() => navigate('/')}
            />
            {
                pathname !== '/auth' ? (
                    <div className='icons-ct'onClick={() => navigate('/profile')} >
                        <img 
                            src='https://i.imgur.com/k10OkaA.png' 
                            alt='profile' 
                            width='60px' 
                            height='auto' 
                        />
                        <span className='nome'>{nome}</span>
                    </div>
                ) : null
            }
        </header>
    )
}

export default Header